import api from '@/services/gateway/api';

const baseUrl = 'camp/superapp-feedback/features';
const JSON_HEADERS = { headers: { 'Content-Type': 'application/json' } };

export default {
  namespaced: true,
  state: {
    list: [],
    item: null
  },
  getters: {
    getList: state => state.list,
    getItem: state => state.item
  },
  mutations: {
    setList (state, list) {
      state.list = list;
    },
    setItem (state, item) {
      state.item = item;
    },
    replaceItem (state, item) {
      state.list = state.list.map(row => (row.id === item.id ? item : row));
    },
    removeItem (state, id) {
      state.list = state.list.filter(row => row.id !== id);
    }
  },
  actions: {
    actionGetList ({ commit }) {
      return api.get(baseUrl).then(({ data }) => {
        commit('setList', data.data);
        return data.data;
      });
    },
    actionGetItem ({ commit }, id) {
      commit('setItem', null);
      return api.get(`${baseUrl}/${id}`).then(({ data }) => {
        commit('setItem', data.data);
        return data.data;
      });
    },
    actionCreate (context, payload) {
      return api.post(baseUrl, payload, JSON_HEADERS).then(({ data }) => data.data);
    },
    actionUpdate (context, { id, payload }) {
      return api.put(`${baseUrl}/${id}`, payload, JSON_HEADERS).then(({ data }) => data.data);
    },
    actionToggleVisibility ({ commit }, { id, is_visible: isVisible }) {
      return api.patch(`${baseUrl}/${id}/visibility`, { is_visible: isVisible }, JSON_HEADERS).then(({ data }) => {
        commit('replaceItem', data.data);
        return data.data;
      });
    },
    actionRemove ({ commit }, id) {
      return api.delete(`${baseUrl}/${id}`).then(() => commit('removeItem', id));
    }
  }
};
